<template>
  <main class="mt2 mb4">
    <div class="clearfix">
      <button @click="addNew()" id="pageForm" class="float-left p2 outlined-action-button flex justify-center items-center gibson h5 not-rounded">
        <span>Tilføj ny e-mail</span>
        <span class="mx2">
          <i class="el-icon-right"></i>
        </span>
      </button>
      <div class="px2 float-right" style="padding-right: 160px;">
        <p class="darkblue-background white h6 regular center line-height-golden mb0 gibson p2">
          Antal E-mail: <span class="semi-bold">{{ numemailused }}</span> ud af <span class="semi-bold">{{ numemail }}</span>
        </p>
      </div>
      <div class="clearfix"></div>
      <b-collapse id="collapse1" v-model="showCollapse" class="my4">
        <form @submit.stop.prevent="website_email" id="formSubmit" class="xs-col-12 sm-col-12 md-col-6 lg-col-6">
          <div class="clearfix mb2">
            <b-form-group label="E-mail" label-for="" class="h6 darkblue gibson line-height-1 mb1">
              <b-form-input id="title" v-model="Email.email" class="not-rounded border-none p2 muted-background gibson darkblue" required></b-form-input>
              <b-form-text id="input-live-help">Eksempel: info@{{ emaildomain }}</b-form-text>
            </b-form-group>
          </div>
          <div class="clearfix">
            <div class="col-12 px0">
              <b-form-group label="Kodeord" label-for="" class="h6 darkblue gibson line-height-1 mb1">
              <vue-password v-model="Email.password" @input="password_check" :strengthMessages="strengthMessages" required  classes="not-rounded border-none muted-background mb1 pt3 pr0 pb3 pl3 h5 flex justify-center items-center" placeholder="Kodeord" autocomplete="current-password" :score="score"></vue-password>
              </b-form-group>
            </div>
          </div>
          <div class="py2"></div>
          <div class="clearfix">
            <div class="col-12 px0">
              <b-form-group label="Gentag kodeord" label-for="" class="h6 darkblue gibson line-height-1 mb1">
              <b-form-input v-model="Email.newpassword" type="password" placeholder="Gentag kodeord" required class="not-rounded border-none muted-background mb3 pt3 pr0 pb3 pl3 h5 flex justify-center items-center" autocomplete="current-password"></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="clearfix">
            <div class="alert alert-danger" v-if="Email.errorMessage">{{ Email.errorMessage }}</div>
          </div>
          <div class="clearfix">
            <div class="col-12 px2">
              <p class="frmValidation" :class="{'frmValidation--passed' : Email.password.length > 8}"><i class="mr1" :class="Email.password.length > 8 ? 'el-icon-check' : 'el-icon-close'"></i> Længere end 8 karakterer</p>
              <p class="frmValidation" :class="{'frmValidation--passed' :has_uppercase }"><i class="mr1" :class="has_uppercase ? 'el-icon-check' : 'el-icon-close'"></i> Indeholder et stort bogstav</p>
              <p class="frmValidation" :class="{'frmValidation--passed' :has_lowercase }"><i class="mr1" :class="has_lowercase ? 'el-icon-check' : 'el-icon-close'"></i> Indeholder et lille bogstav</p>
              <p class="frmValidation" :class="{'frmValidation--passed' : has_number }"><i class="mr1" :class="has_number ? 'el-icon-check' : 'el-icon-close'"></i> Indeholder et tal</p>
              <p class="frmValidation" :class="{'frmValidation--passed' : has_special }"><i class="mr1" :class="has_special ? 'el-icon-check' : 'el-icon-close'"></i> Indeholder et specialkarakter</p>
            </div>
          </div>

          <div class="clearfix py2 mb2">
            <b-form-group label="Gendannelses e-mail" label-for="" class="h6 darkblue gibson line-height-1 mb1">
              <b-form-input id="title" v-model="Email.recovery_email" class="not-rounded border-none p2 muted-background gibson darkblue" required></b-form-input>
            </b-form-group>
          </div>
          <div class="col-12 px0 flex justify-between items-center">
            <button type="button" v-b-toggle.collapse1 class="not-rounded outlined-disabled-button p2 flex justify-center items-center gibson h5">
              <span class="pr2"><i class="el-icon-back"></i></span>
              <span>Luk</span>
            </button>
            <button type="submit"  class="not-rounded action-button p2 flex justify-center items-center gibson h5 regular" variant="success" size="lg" :disabled="isLoadingReview">
              <span>
                Gem
              </span>
              <span class="pl2"><i class="el-icon-right"></i></span>
            </button>
          </div>
        </form>
      </b-collapse>
    </div>
    <div class="clearfix">
      <table class="table is-fullwidth is-striped">
        <thead>
          <tr>
            <th><span class="h5 darkblue gibson line-height-1">E-mail</span></th>
            <th><span class="h5 darkblue gibson line-height-1">Storage</span></th>
            <th><span class="h5 darkblue gibson line-height-1">Used</span></th>
            <th><span class="h5 darkblue gibson line-height-1">Gendannelses e-mail</span></th>
            <th><span class="h5 darkblue gibson line-height-1">Aktion</span></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(post, index) in filteredPosts" :key="index">
            <td class="post-title-cell">{{post.username}}</td>
            <td class="post-category-cell">5000 mb.</td>
            <td class="post-author-cell" >{{ post.storagequota_used }} mb.</td>
            <td class="post-author-cell" >{{ post.recovery_email }}</td>
            <td class="post-author-cell">
              <b-button size="sm" class="rounded" @click="resetEmail(post)"  variant="outline-success">
                <span class="far fa-edit"> </span> Gendan adgangskode
              </b-button>

              <b-button size="sm" class="rounded" @click="changeEmail(post)" v-if="post.resetdone"   variant="outline-info">
                <span class="far fa-edit"> </span> Skifte adgangskode
              </b-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <b-modal
      hide-footer
      v-model="modalShowReset"
      ref="modal"
      size="lg"
      class="px2 pb4"
      title="Skifte adgangskode"
    >
      <form @submit.stop.prevent="website_email_reset" id="formSubmit2" class="xs-col-12 sm-col-12 md-col-12 lg-col-12">
        <div class="clearfix mb2">
          <b-form-group label="Gendannelseskode" label-for="" class="h6 darkblue gibson line-height-1 mb1">
            <b-form-input id="title" v-model="Reset.recovery_code" class="not-rounded border-none p2 muted-background gibson darkblue" required></b-form-input>
          </b-form-group>
        </div>
        <div class="clearfix">
          <div class="col-12 px0">
            <b-form-group label="Kodeord" label-for="" class="h6 darkblue gibson line-height-1 mb1">
              <vue-password v-model="Reset.password" @input="password_check" :strengthMessages="strengthMessages" required  classes="not-rounded border-none muted-background mb1 pt3 pr0 pb3 pl3 h5 flex justify-center items-center" placeholder="Kodeord" autocomplete="current-password" :score="score"></vue-password>
            </b-form-group>
          </div>
        </div>
        <div class="py2"></div>
        <div class="clearfix">
          <div class="col-12 px0">
            <b-form-group label="Gentag kodeord" label-for="" class="h6 darkblue gibson line-height-1 mb1">
              <b-form-input v-model="Reset.newpassword" type="password" placeholder="Gentag kodeord" required class="not-rounded border-none muted-background mb3 pt3 pr0 pb3 pl3 h5 flex justify-center items-center" autocomplete="current-password"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="clearfix">
          <div class="alert alert-danger" v-if="Reset.errorMessage">{{ Reset.errorMessage }}</div>
        </div>
        <div class="clearfix">
          <div class="col-12 px2">
            <p class="frmValidation" :class="{'frmValidation--passed' : Reset.password.length > 8}"><i class="mr1" :class="Reset.password.length > 8 ? 'el-icon-check' : 'el-icon-close'"></i> Længere end 8 karakterer</p>
            <p class="frmValidation" :class="{'frmValidation--passed' :has_uppercase }"><i class="mr1" :class="has_uppercase ? 'el-icon-check' : 'el-icon-close'"></i> Indeholder et stort bogstav</p>
            <p class="frmValidation" :class="{'frmValidation--passed' :has_lowercase }"><i class="mr1" :class="has_lowercase ? 'el-icon-check' : 'el-icon-close'"></i> Indeholder et lille bogstav</p>
            <p class="frmValidation" :class="{'frmValidation--passed' : has_number }"><i class="mr1" :class="has_number ? 'el-icon-check' : 'el-icon-close'"></i> Indeholder et tal</p>
            <p class="frmValidation" :class="{'frmValidation--passed' : has_special }"><i class="mr1" :class="has_special ? 'el-icon-check' : 'el-icon-close'"></i> Indeholder et specialkarakter</p>
          </div>
        </div>
        <div class="col-12 px0 flex justify-between items-center">
          <button type="button" @click="modalShowReset=false" class="not-rounded outlined-disabled-button p2 flex justify-center items-center gibson h5">
            <span class="pr2"><i class="el-icon-back"></i></span>
            <span>Luk</span>
          </button>
          <button type="submit"  class="not-rounded action-button p2 flex justify-center items-center gibson h5 regular" variant="success" size="lg" :disabled="isLoadingReview">
                <span>
                  Gem
                </span>
            <span class="pl2"><i class="el-icon-right"></i></span>
          </button>

        </div>

      </form>
    </b-modal>
    <loading :show="show" :label="label" :overlay="overlay"></loading>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </main>
</template>
<script>
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
import VuePassword from 'vue-password'
import passwordStrength from 'zxcvbn'
export default {
  name: 'webemailcontents',
  components: {
    loading,
    passwordStrength,
    VuePassword,
    Simplert
  },
  props: ['filteredPosts', 'emaildomain', 'numemail', 'numemailused'],
  data () {
    return {
      showModal: false,
      showCollapse: false,
      show: false,
      label: 'Loading...',
      picked: '',
      overlay: true,
      modalShowReset: false,
      isLoadingReview: false,
      Cpage: '',
      Email: {
        email: '',
        recovery_email: '',
        password: '',
        newpassword: '',
        errorMessage: ''
      },
      Reset: {
        username: '',
        recovery_code: '',
        password: '',
        newpassword: '',
        errorMessage: ''
      },
      strengthMessages: ['Meget svagt', 'Svagt', 'Medium', 'Stærkt', 'Meget stærkt'],
      has_number: false,
      has_lowercase: false,
      has_uppercase: false,
      has_special: false,
      header: '',
      kind: '',
      post: '',
      sortKey: 'tittle'
    }
  },
  methods: {
    postDate (epoch) {
      if (!epoch) return // if no time return nothing
      return this.moment(epoch).format('MM/DD/YY | hh:mm')
    },
    pageType (type) {
      if (type === '1') {
        return 'Om os'
      } else if (type === '2') {
        return 'Tjenester'
      } else if (type === '3') {
        return 'Projekt'
      } else if (type === '4') {
        return 'Kontakt'
      }
    },
    password_check: function () {
      this.has_number = /\d/.test(this.form.password)
      this.has_lowercase = /[a-z]/.test(this.form.password)
      this.has_uppercase = /[A-Z]/.test(this.form.password)
      this.has_special = /[!@#\\$%\\^\\&*\\)\\(+=._-]/.test(this.form.password)
    },
    changeEmail (item) {
      this.Reset.username = item.username
      this.modalShowReset = true
    },
    editPage (page) {
      this.Cpage = page
      this.showCollapse = true
      this.Page = this.Cpage
      $('html, body').animate({
        scrollTop: 0
      }, 600)
    },
    sletPage (item) {
      let confirmFn = function () {
        this.$parent.sletPage_remove(item)
      }
      let obj = {
        title: 'Bekræft',
        message: 'Er du sikker på at du vil slette denne side?',
        useConfirmBtn: true,
        onConfirm: confirmFn,
        customConfirmBtnText: 'Bekræft',
        customConfirmBtnClass: 'simplert__confirm bg-success',
        customCloseBtnClass: 'simplert__close bg-secondary',
        customCloseBtnText: 'Luk',
        showXclose: true
      }
      this.$refs.simplert.openSimplert(obj)
    },
    emptyPage () {
    },
    addNew () {
      this.emptyPage()
      this.showCollapse = true
      this.$emit('Reload')
    },
    resetEmail (item) {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'reset_email', salesPerson: this.salesPerson, levid: this.haaId, username: item.username}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'En nulstilling af adgangskode sendt til din gendannelses-e-mail!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              item.resetdone = true
              this.$refs.simplert.openSimplert(obj)
              this.emptyPage()
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    sletPage_remove (item) {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'website_del', salesPerson: this.salesPerson, levid: this.haaId, item: item.id}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
              this.emptyPage()
              this.$emit('Reload')
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    website_email_reset () {
      this.Reset.errorMessage = ''
      if (this.Reset.password !== this.Reset.newpassword) {
        this.Reset.errorMessage = 'Du har indtastet to passwords som ikke er ens. Prøv igen.'
        return
      }
      this.score = passwordStrength(this.Reset.password).score
      if (this.score < 3) {
        this.Reset.errorMessage = 'Dit password er ikke stærkt nok.'
        return
      }
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'website_email_reset', salesPerson: this.salesPerson, levid: this.haaId, Reset: JSON.stringify(this.Reset)}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.modalShowReset = false
              this.Reset.password = ''
              this.Reset.recovery_code = ''
              this.Reset.newpassword = ''
              this.$refs.simplert.openSimplert(obj)
              this.emptyPage()
              this.$emit('Reload')
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    website_email () {
      if (this.numemailused >= this.numemail) {
        let obj = {
          title: 'Fejl',
          message: 'Du skal købe flere e-mail',
          type: 'error',
          customCloseBtnText: 'Luk'
        }
        this.$refs.simplert.openSimplert(obj)
        return
      }
      this.Email.errorMessage = ''
      if (this.Email.password !== this.Email.newpassword) {
        this.Email.errorMessage = 'Du har indtastet to passwords som ikke er ens. Prøv igen.'
        return
      }
      this.score = passwordStrength(this.Email.password).score
      if (this.score < 3) {
        this.Email.errorMessage = 'Dit password er ikke stærkt nok.'
        return
      }
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'website_email', salesPerson: this.salesPerson, levid: this.haaId, Email: JSON.stringify(this.Email)}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
              this.emptyPage()
              this.$emit('Reload')
              this.showCollapse = false
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this.createImage(files[0])
    },
    createImage (file) {
      var reader = new FileReader()
      var vm = this
      reader.onload = (e) => {
        vm.Page.image = e.target.result
      }
      reader.readAsDataURL(file)
    },
    removeImage: function (e) {
      this.Page.image = ''
    }
  }
}
</script>
<style>
#collapse1 > div > .card-body {
}
.tab-content {
  border:0;
}
.col-form-label {
  font-weight: 600;
}
.card-header {
  background: none;
}
.tab-content .tab-pane {
  padding-left: 0;
  padding-right: 0;
}
.frmField{background-color:white; color:#495057; line-height: 1.25; font-size: 16px; font-family: 'Roboto', sans-serif; border:0; padding: 10px; border:1px solid #dbdbdb;  border-radius: 3px; width:90%;}
.frmLabel{display: block; margin-bottom: 10px; font-weight: bold;}
.frmValidation{font-size: 13px; }
.frmValidation--passed{color:#717b85;}
.frmIcon{color:#EB0029;}
.frmValidation--passed .frmIcon{color:#0fa140;}
.howToBuild{ text-align:center; color:purple;}
.howToBuild a{ color:grey; font-weight:bold; text-decoration:none; text-transform:uppercase; }
.VuePassword__Meter {
  height: 4px;
}
</style>
<style v-if="!showMobile">
.frmValidation{
  font-size: 18px;
  padding: 6px;
  float: left;
  background-color: #f1f1f1;
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// webemailcontents.vue?67a4a510